<template>
  <div class="container-fluid border-end">
    <form @submit.prevent="submitForm">
      <div class="mb-3">
        <label for="inputSipName" class="form-label">SIP Name</label>
        <input
          v-model="inputSipName"
          type="text"
          class="form-control"
          id="sipName"
        />
      </div>
      <div class="mb-3">
        <label for="status" class="form-label">Status</label>
        <select v-model="inputStatus" id="status" class="form-select">
          <option selected value="">Select...</option>
          <option>Created</option>
          <option>Failed</option>
          <option>Ingesting</option>
          <option>Packages Created</option>
          <option>Rejected</option>
          <option>Stored</option>
        </select>
      </div>

      <div class="d-block">
        <button
          class="btn btn-clear btn-outline-secondary"
          type="button"
          @click="clearAll"
        >
          Clear All
        </button>
        <button
          class="btn btn-search btn-primary"
          type="button"
          @click="submitForm"
        >
          Search
        </button>
      </div>
    </form>
  </div>
</template>
<script setup lang="ts">
import { ref } from "vue";

const inputSipName = ref("");
const inputStatus = ref("");

const emit = defineEmits(["listen-sip-search"]);

const submitForm = () => {
  let searchField = {
    sipName: inputSipName.value,
    sipStatus: inputStatus.value,
  };
  emit("listen-sip-search", searchField);
};

const clearAll = () => {
  inputSipName.value = "";
  inputStatus.value = "";
  let searchField = {
    sipName: inputSipName.value,
    sipStatus: inputStatus.value,
  };
  emit("listen-sip-search", searchField);
};
</script>
<style scoped>
.container-fluid {
  position: fixed;
  padding-top: 20px;
  width: 24%;
  height: 100%;
  overflow: auto;
}
.btn-clear {
  margin-top: 1rem;
  margin-right: 1%;
  width: 49%;
  margin-bottom: 5rem;
}
.btn-search {
  margin-top: 1rem;
  margin-left: 1%;
  width: 49%;
  margin-bottom: 5rem;
}
</style>
